import React, { useEffect } from 'react'
import profileAction from './../../redux/profile/actions'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux';
import Style from './MyProfile.module.css'

const dateFormat = process.env.REACT_APP_DATE_FORMAT;
const { getProfileDataList } = profileAction;

const icons = {
    name: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    email: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>,
    contact: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.4 2.1L8.1 9.7a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.4c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.9 2.2z" /></svg>,
    address: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></svg>,
    city: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4M10 10h4M10 14h4M10 18h4" /></svg>,
    zip: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18" /><path d="M9 21V9" /></svg>,
    state: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18" /><path d="M5 21V7l8-4v18" /><path d="M19 21V11l-6-4" /></svg>,
    joined: <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>,
};

const MyProfile = () => {
    const dispatch = useDispatch();
    const profileList = useSelector((state) => state.profile.profileListResult);

    useEffect(() => {
        dispatch(getProfileDataList());
    }, []);

    const profile = profileList && profileList.length > 0 ? profileList[0] : null;

    const Row = ({ icon, label, value }) => (
        <div className={Style.infoRow}>
            <div className={Style.infoIcon}>{icon}</div>
            <div>
                <p className={Style.infoLabel}>{label}</p>
                {value ? (
                    <p className={Style.infoValue}>{value}</p>
                ) : (
                    <p className={Style.infoValueMuted}>Not available</p>
                )}
            </div>
        </div>
    );

    return (
        <div className={Style.wrapper}>
            {/* Header */}
            <div className={Style.card}>
                <div className={Style.cardTop}>
                    <div className={Style.chip} />
                    <p className={Style.eyebrow}>{profile ? profile.Role : ''} access</p>
                </div>
                <div className={Style.identityRow}>
                    <div className={Style.avatarRing}>
                        <div className={Style.avatarInner}>
                            <p className={Style.avatarText}>
                                {profile ? profile.Username.charAt(0).toUpperCase() : ''}
                            </p>
                        </div>
                    </div>
                    <div>
                        <h3 className={Style.name}>{profile ? profile.Username : ''}</h3>
                        <div className={Style.roleRow}>
                            <span className={Style.roleRule} />
                            <span className={Style.role}>{profile ? profile.Role : ''}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* About */}
            <div className={Style.aboutCard}>
                <div className={Style.aboutHeader}>
                    <h4 className={Style.aboutTitle}>About user</h4>                    
                </div>

                <div className={Style.infoGrid}>
                    <Row icon={icons.name} label="Name" value={profile?.Name} />
                    <Row icon={icons.email} label="Email" value={profile?.ContactEmailID} />
                    <Row icon={icons.contact} label="Contact" value={profile?.ContactNumber} />
                    <Row icon={icons.address} label="Address" value={profile?.Address} />
                    <Row icon={icons.city} label="City" value={profile?.City} />
                    <Row icon={icons.zip} label="Zip code" value={profile?.ZipCode} />
                    <Row icon={icons.state} label="State" value={profile?.State} />
                    <Row
                        icon={icons.joined}
                        label="Joined"
                        value={profile ? moment(profile.CreatedDtTm).format(dateFormat) : ''}
                    />
                </div>
            </div>
        </div>
    )
}

export default MyProfile
